export default __webpack_public_path__ + "static/media/Ballroll_00133.9d87075a.png";